import React               from 'react';
import LoaderButton        from '../../shared/loader-button/loader-button.jsx';
import Alert               from '../../shared/alert';
import Back                from '../../shared/back';
import LocaleString        from '../../shared/locale-string';
import { CloseCircleIcon } from '../../shared/icons/icons.jsx';
import isEmailValid        from '../../../utils/email-validator.js';

import './contact.scss';

class Contact extends React.Component {
    static propTypes = {};

    constructor( props ) {
        super( props );

        this.state = {
            subject: '',
            message: '',
            emailAddress: this.props.emailAddress
        };
    }

    componentWillUnmount() {
        this.props.contactErrors.forEach( error => this.props.dismissError( error ) );
        this.props.contactSuccessMessage.forEach( successMsg => this.props.dismissSuccess( successMsg ) );
    }

    UNSAFE_componentWillReceiveProps( nextProps ) {//eslint-disable-line
        if ( !this.props.done && nextProps.done ) {
            this.clearInputs();
        }
    }

    clearInputs = () => {
        this.setState( { subject: '', message: '' } );
    };

    handleField = ( event ) => {
        const { name, value } = event.target;
        this.setState( { [ name ]: value } );

        if( this.props.done === true ) {
            this.props.dismissSuccess();
        }
    };

    onSubmit = () => {
        const {
            contactErrors,
            sendContact,
            dismissError
        } = this.props;

        contactErrors.forEach( error => dismissError( error ) );
        sendContact( { ...this.state, productName: 'PRO Accounts' } );
    };

    render() {
        const {
            subject,
            message,
            emailAddress
        } = this.state;

        const {
            busy,
            done,
            contactErrors,
            contactSuccessMessage,
            dismissError,
            dismissSuccess
        } = this.props;

        return (
            <div className="contact-form narrow-form" role="form">

                <div className="title" role="banner">
                    <Back className="back">
                        <CloseCircleIcon />
                    </Back>
                    <h1><LocaleString code="contactUs.form.headerLabel" /></h1>
                </div>

                <label htmlFor="emailAddress">
                    <LocaleString code="contactUs.input.emailLabel" />
                </label>
                <input
                    type="email"
                    name="emailAddress"
                    id="emailAddress"
                    tabIndex="1"
                    required={ true }
                    value={ emailAddress }
                    onChange={ this.handleField }
                />

                <label htmlFor="subject">
                    <LocaleString code="contactUs.input.subjectLabel" />
                </label>
                <input
                    type="text"
                    name="subject"
                    tabIndex="2"
                    id="subject"
                    value={ subject }
                    onChange={ this.handleField }/>

                <label htmlFor="message">
                    <LocaleString code="contactUs.input.messageLabel" />
                </label>
                <textarea
                    type="text"
                    name="message"
                    tabIndex="3"
                    id="message"
                    value={ message }
                    onChange={ this.handleField }/>

                {
                    contactErrors.length !== 0 && contactErrors.map( ( error, index ) =>
                        <Alert type={ 'error' } onDismiss={ () => dismissError( error ) } key={ index }>
                            <p>{ error.responseMessage }</p>
                        </Alert>
                    )
                }

                {
                    contactSuccessMessage.length !== 0 &&
                    <Alert type={ 'success' } onDismiss={ () => dismissSuccess( contactSuccessMessage ) }>
                        <p><LocaleString code={ contactSuccessMessage[ 0 ].message } /></p>
                    </Alert>
                }

                <LoaderButton
                    busy={ busy }
                    onClick={ this.onSubmit }
                    disabled={ !subject.length || !message.length || !isEmailValid( emailAddress ) }
                    tabIndex="4"
                    done={ done }>
                    <LocaleString code="contactUs.button.submitLabel" />
                </LoaderButton>

            </div>
        );
    }
}

export default Contact;
